import styled from 'styled-components';

export const Div = styled.div`
  position: relative;

  overflow-y: auto;
  .page_title {
    flex: auto;
    margin: 20px 0 0 2%;
    font-size: 21px;
    font-weight: normal;
    font-family: 'Roboto';
    color: #777;
  }

  .ant-tabs {
    flex: auto;
    margin: 20px 2% 0 2%;
  }

  .ant-tabs-tab {
    color: #858b97;
    padding: 12px 16px;
    &:hover,
    &:active,
    &:focus {
      color: #000;
    }
  }
  .ant-tabs-ink-bar {
    background: #000;
  }

  .ant-tabs-ink-bar ant-tabs-ink-bar-animated {
    border-bottom: #000;
  }

  .ant-tabs-nav::before {
    border-top: 1px solid #c4c9d0;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #000;
  }

  .footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    text-align: center;
    padding: 32px 0;
    background-color: #fff;
    z-index: 9999;
  }
`;

export const Title = styled.h1`
  margin: 20px 0 0 2%;
  font-size: 21px;
  font-weight: 600;
  font-family: 'Roboto';
  color: #000;
`;
